import React, { useMemo, useCallback } from 'react';
import { Dropdown } from 'antd';
import MailMenu from './menu';
import MailMenuMult from './multMenu';
const MailListWrap = props => {
    const { activeMailId, visible, setVisible, moreAccounts = false } = props;
    const isMult = useMemo(() => {
        return Array.isArray(activeMailId) && activeMailId.length > 1;
    }, [activeMailId]);
    const domPropsRender = useCallback((mails, menuConfig) => {
        return {
            'data-test-id': 'mail-menu-list-' + (menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.key),
        };
    }, []);
    return (React.createElement(Dropdown, { overlayClassName: "u-tree-dropmenu", visible: visible, onVisibleChange: visible => {
            visible ? '' : setVisible(visible);
        }, placement: "bottomLeft", overlay: isMult ? (React.createElement(MailMenuMult, Object.assign({}, props, { visible: visible, setVisible: setVisible, domProps: domPropsRender, moreAccounts: moreAccounts }))) : (React.createElement(MailMenu, Object.assign({}, props, { visible: visible, setVisible: setVisible, domProps: domPropsRender }))), trigger: ['contextMenu'] },
        React.createElement("div", null, props.children)));
};
export default MailListWrap;
